import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_ND_DEMO_TCA_END = {
  title:
    "Speak to us to find out how Infosys \nTelco Cloud Automation can \ntransform your business.",
  bgImage: "ILO/TCA/TCA_Demo_bg.jpg",
  optionsButtons: [
    {
      label: "Overview",
      onClick: () => setCurrentPage("ILO_301"),
      type: "transparent",
      startIcon: "arrow-left",
    },
    {
      label: "RESTART DEMO",
      onClick: () => setCurrentPage("ILO_306"),
      endIcon: "arrow-right",
    },
    {
      label: "SELECT ANOTHER DEMO",
      onClick: () => setCurrentPage("ILO_305"),
      endIcon: "arrow-right",
    },
  ],
};
